import boxService from 'stores/_services/boxService';

export default function getAnalysisContext(baseRoute?: string): Promise<{
    scanId?: string;
    boxId?: string;
    route?: string;
    analysisFilter: Record<string, unknown> | undefined;
}> {
    return new Promise((resolve) => {
        // Wait until location has been updated to pull new search params
        setTimeout(async () => {
            const location = window.location;
            let route = baseRoute;

            const queryParams = new URLSearchParams(location.search);
            const item: { id?: string; isBox: boolean } = { id: undefined, isBox: true };
            let filter;

            if (!location.pathname.match(/analyze/i)) {
                filter = {};
            } else if (queryParams.has('boxId')) {
                item.isBox = true;
                item.id = queryParams.get('boxId') || '';

                const box = await boxService.getBox(item.id);

                filter = box?.createdBy ? { scannedOn: { gte: box?.filter.startDate, lt: box?.filter.endDate } } : { scannedOn: { gte: box?.filterOn } };
            }

            if (baseRoute) {
                route = `box${baseRoute}`;
            }

            //TODO: figure out how to return box filters neatly
            resolve({
                route,
                [item.isBox ? 'boxId' : 'scanId']: item.id,
                analysisFilter: filter
            });
        });
    });
}
